import React, { useState, useRef, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom/client';

import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

import Select from 'react-select';

import Overlay from 'react-overlays/Overlay';
import Modal from 'react-overlays/Modal';
import useRootClose from 'react-overlays/useRootClose';

import PhotoSwipeLightbox from 'photoswipe/src/js/lightbox/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/src/photoswipe.css';

import { useQueryParams } from 'raviger';

import jsCookies from 'js-cookie';
import { addDays, toDate } from 'date-fns';

import useWindowSize from 'use-window-size-v2';

import Logos from './logos';
//import trans from './trans';

/*let content = 'key;lang (SL)\n';
for (let key in trans) {
	const val = trans[key]['sl']
		.replaceAll('\n', '\\n')
		.replaceAll('\r', '');
	content += key;
	content += ';';
	content += val;
	content += '\n';
}
console.log(content);*/

const DEV_MODE = process.env.DEV_MODE == 'true';
let BASE_URL = 'http://test.lodgge-api.local.mojaspletnastran.si/';
let CLIENT = 'test';
if (!DEV_MODE && document.location.host.indexOf('reservations.assistpro.eu') != -1) {
	CLIENT = document.location.host.substring(0, document.location.host.indexOf('reservations.assistpro.eu') - 1);
	BASE_URL = 'https://' + CLIENT + '.api.assistpro.eu/';
}
else if (document.location.host.indexOf('local.mojaspletnastran.si') != -1) {
	CLIENT = document.location.host.substring(0, document.location.host.indexOf('local.mojaspletnastran.si') - 1);
	BASE_URL = 'http://' + CLIENT + '.lodgge-api.local.mojaspletnastran.si/';
}
console.log({ CLIENT, BASE_URL });
document.querySelector(':root').className = CLIENT;

const service_images = {
	'tent-small.png':               new URL('/src/images/services/tent-small.png',               import.meta.url),
	'tent-medium.png':              new URL('/src/images/services/tent-medium.png',              import.meta.url),
	'tent-xl.png':                  new URL('/src/images/services/tent-xl.png',                  import.meta.url),
	'tent-xxl.png':                 new URL('/src/images/services/tent-xxl.png',                 import.meta.url),
	
	'caravan-small.png':            new URL('/src/images/services/caravan-small.png',            import.meta.url),
	'caravan-large.png':            new URL('/src/images/services/caravan-large.png',            import.meta.url),
	'caravan-xl.png':               new URL('/src/images/services/caravan-xl.png',               import.meta.url),
	'caravan-xxl.png':              new URL('/src/images/services/caravan-xxl.png',              import.meta.url),
	
	'motorhome-small.png':          new URL('/src/images/services/motorhome-small.png',          import.meta.url),
	'motorhome-medium.png':         new URL('/src/images/services/motorhome-medium.png',         import.meta.url),
	'motorhome-large.png':          new URL('/src/images/services/motorhome-large.png',          import.meta.url),
	'motorhome-xl.png':             new URL('/src/images/services/motorhome-xl.png',             import.meta.url),
	
	'roof-tent-small.png':          new URL('/src/images/services/roof-tent-small.png',          import.meta.url),
	'roof-tent-medium.png':         new URL('/src/images/services/roof-tent-medium.png',         import.meta.url),
	'roof-tent-large.png':          new URL('/src/images/services/roof-tent-large.png',          import.meta.url),
	
	'transport-trailer-small.png':  new URL('/src/images/services/transport-trailer-small.png',  import.meta.url),
	'transport-trailer-medium.png': new URL('/src/images/services/transport-trailer-medium.png', import.meta.url),
	'transport-trailer-large.png':  new URL('/src/images/services/transport-trailer-large.png',  import.meta.url),
};

const getTrans = (trans, key, lang) => trans === undefined ? '' : (trans[key] === undefined ? '' : (trans[key][lang] === undefined ? '' : trans[key][lang]));

async function loadTrans(api_url) {
	let response = await fetch(api_url + 'PublicReservations/v2/translations');
	return await response.json();
}
async function loadAccommodations(api_url) {
	let response = await fetch(api_url + 'PublicReservations/v2/accommodations');
	return await response.json();
}
async function loadCountries(api_url) {
	let response = await fetch(api_url + 'PublicReservations/v2/countries');
	return await response.json();
}
async function calculatePrices(api_url, reservations) {
	const form_data = new FormData();
	form_data.append('reservations', JSON.stringify(reservations));
	
	let response = await fetch(api_url + 'PublicReservations/v2/calculate-prices', {
		method: 'POST',
		body: form_data,
	});
	return await response.json();
}
async function saveReservation(
	api_url,
	lang,
	reservations,
	agree_1,
	agree_2,
	customer_name,
	customer_surname,
	customer_email,
	customer_email_again,
	customer_id_country,
	customer_phone,
	customer_address,
	customer_post_code_name,
	customer_note
) {
	const form_data = new FormData();
	form_data.append('lang',                    lang                        );
	form_data.append('reservations',            JSON.stringify(reservations));
	form_data.append('agree_1',                 agree_1 ? 'true' : 'false'  );
	form_data.append('agree_2',                 agree_2 ? 'true' : 'false'  );
	form_data.append('customer_name',           customer_name               );
	form_data.append('customer_surname',        customer_surname            );
	form_data.append('customer_email',          customer_email              );
	form_data.append('customer_email_again',    customer_email_again        );
	form_data.append('customer_id_country',     customer_id_country         );
	form_data.append('customer_phone',          customer_phone              );
	form_data.append('customer_address',        customer_address            );
	form_data.append('customer_post_code_name', customer_post_code_name     );
	form_data.append('customer_note',           customer_note               );
	
	let response = await fetch(api_url + 'PublicReservations/v2/save-reservation', {
		method: 'POST',
		body: form_data,
	});
	return await response.json();
}
async function getAccommodationPricesForTimeRange(api_url, date_from, date_until) {
	const params = [
		'date_from=' + encodeURIComponent(date_from),
		'date_until=' + encodeURIComponent(date_until),
	];
	
	let response = await fetch(api_url + 'PublicReservations/v2/accommodation-prices?' + params.join('&'));
	return await response.json();
}
async function getAccommodationOccupancy(api_url, date_from, date_until) {
	const params = [
		'date_from=' + encodeURIComponent(date_from),
		'date_until=' + encodeURIComponent(date_until),
	];
	
	let response = await fetch(api_url + 'PublicReservations/v2/accommodation-occupancy?' + params.join('&'));
	return await response.json();
}

const dateToISO = date => {
	const y = date.getFullYear();
	const m = date.getMonth() + 1;
	const d = date.getDate();
	return y + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d;
};

const formatNumber = (value, decimals) => value.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });

function App(props) {
	//const [ accommodationType, setAccommodationType ] = useState(null);
	//const [ personCount, setPersonCount ] = useState([ 0, 0, 0 ]);
	
	const [ trans,                  setTrans                  ] = useState({});
	const [ accommodations,         setAccommodations         ] = useState(null);
	const [ itemsByIds,             setItemsByIds             ] = useState(null);
	const [ countries,              setCountries              ] = useState(null);
	const [ cart,                   setCart                   ] = useState([]);
	const [ cartWithPrices,         setCartWithPrices         ] = useState([]);
	const [ successDialogOpen,      setSuccessDialogOpen      ] = useState(false);
	const [ errorDialogOpen,        setErrorDialogOpen        ] = useState(false);
	const [ errorDialogMessage,     setErrorDialogMessage     ] = useState(null);
	const [ itemPrices,             setItemPrices             ] = useState({});
	const [ accommodationOccupancy, setAccommodationOccupancy ] = useState({});
	const [ groupDialogOpen,        setGroupDialogOpen        ] = useState(false);
	
	const [ customer_agree_1,        setCustomerAgree1       ] = useState('');
	const [ customer_agree_2,        setCustomerAgree2       ] = useState('');
	const [ customer_name,           setCustomerName         ] = useState('');
	const [ customer_surname,        setCustomerSurname      ] = useState('');
	const [ customer_email,          setCustomerEmail        ] = useState({ value: '', valid: false });
	const [ customer_email_again,    setCustomerEmailAgain   ] = useState({ value: '', valid: false });
	const [ customer_id_country,     setCustomerIdCountry    ] = useState('');
	const [ customer_phone,          setCustomerPhone        ] = useState('');
	const [ customer_address,        setCustomerAddress      ] = useState('');
	const [ customer_post_code_name, setCustomerPostCodeName ] = useState('');
	const [ customer_note,           setCustomerNote         ] = useState('');
	
	const [ cartEditSelectedItem,    setCartEditSelectedItem ] = useState(null);
	
	console.log({ cart });
	
	// only execute once
	useEffect(() => {
		loadTrans         (BASE_URL).then(val => setTrans         (val));
		loadAccommodations(BASE_URL).then(val => setAccommodations(val));
		loadCountries     (BASE_URL).then(val => setCountries     (val));
		
		let link;
		
		link       = document.createElement('link');
		link.rel   = 'icon';
		link.type  = 'image/png';
		link.sizes = '32x32';
		link.href  = '/images/clients/' + CLIENT + '/favicon-32x32.png';
		document.getElementsByTagName('head')[0].appendChild(link);
		
		link       = document.createElement('link');
		link.rel   = 'icon';
		link.type  = 'image/png';
		link.sizes = '16x16';
		link.href  = '/images/clients/' + CLIENT + '/favicon-16x16.png';
		document.getElementsByTagName('head')[0].appendChild(link);
		
		link       = document.createElement('link');
		link.rel   = 'shortcut icon';
		link.href  = '/images/clients/' + CLIENT + '/favicon.ico';
		document.getElementsByTagName('head')[0].appendChild(link);
	}, []);
	
	const [ {
		lang,
		accommodationType,
		personCount,
		dateFrom,
		dateUntil,
		page,
	}, setQuery ] = useQueryParams();
	
	const paramLang              = lang              === undefined ? 'sl'        : lang;
	const paramAccommodationType = accommodationType === undefined ? null        : accommodationType;
	const paramPersonCount       = personCount       === undefined ? { adult: 1, child_1: 0, child_2: 0 } : JSON.parse(personCount);
	const paramDateFrom          = dateFrom          === undefined || dateFrom  == '' ? null : new Date(dateFrom + 'T12:00:00');
	const paramDateUntil         = dateUntil         === undefined || dateUntil == '' ? null : new Date(dateUntil + 'T12:00:00');
	const paramPage              = page              === undefined ? 'index'     : page;
	console.log({
		paramDateFrom,
		dateFrom,
		paramDateUntil,
		dateUntil,
	});
	
	const getCurrentParamsForQuery = () => {
		return {
			lang:              paramLang,
			accommodationType: paramAccommodationType,
			personCount:       JSON.stringify(paramPersonCount),
			dateFrom:          paramDateFrom  === null ? '' : dateToISO(paramDateFrom),
			dateUntil:         paramDateUntil === null ? '' : dateToISO(paramDateUntil),
			page:              paramPage,
		};
	};
	const setLang              = val => setQuery({ ...getCurrentParamsForQuery(), lang:              val });
	const setAccommodationType = val => setQuery({ ...getCurrentParamsForQuery(), accommodationType: val });
	const setPersonCount       = val => setQuery({ ...getCurrentParamsForQuery(), personCount:       JSON.stringify(val) });
	const setPage              = val => setQuery({ ...getCurrentParamsForQuery(), page:              val });
	const setDateRange = (from, until) => setQuery({
		...getCurrentParamsForQuery(),
		dateFrom:  dateToISO(from),
		dateUntil: dateToISO(until),
	});
	
	// load cart from cookie, if available
	useEffect(() => {
		const cookie_cart = jsCookies.get('cart');
		if (cookie_cart !== undefined) {
			console.log('setting cart from cookie: ' + cookie_cart);
			const cart = JSON.parse(cookie_cart);
			for (let i=0; i<cart.length; i++) {
				cart[i].date_from  = new Date(cart[i].date_from );
				cart[i].date_until = new Date(cart[i].date_until);
			}
			
			setCart(cart);
		}
	}, []);
	
	// update prices
	useEffect(() => {
		async function load() {
			const response = await calculatePrices(BASE_URL, cart.map(x => {
				return {
					id_item:             x.id_item,
					date_from:           dateToISO(x.date_from) + 'T12:00:00',
					date_until:          dateToISO(x.date_until) + 'T12:00:00',
					person_count:        x.person_count,
					services:            x.services,
					additional_services: x.additional_services,
				};
			}));
			setCartWithPrices(response);
		}
		load();
		
		jsCookies.set('cart', JSON.stringify(cart));
	}, [ cart ]);
	
	// update items by ids
	useEffect(() => {
		const items = {};
		for (let type in accommodations) {
			for (let id in accommodations[type].accommodation_items) {
				items[id] = accommodations[type].accommodation_items[id];
			}
		}
		setItemsByIds(items);
		
		if (paramAccommodationType === null && accommodations !== null && Object.keys(accommodations).length === 1) {
			setAccommodationType(Object.keys(accommodations)[0]);
		}
	}, [ accommodations ]);
	
	useEffect(() => {
		function load() {
			if (paramDateFrom === null || paramDateUntil === null) return;
			
			getAccommodationPricesForTimeRange(BASE_URL, dateToISO(paramDateFrom), dateToISO(paramDateUntil))
				.then(response => setItemPrices(response));
			
			getAccommodationOccupancy(BASE_URL, dateToISO(paramDateFrom), dateToISO(paramDateUntil))
				.then(response => setAccommodationOccupancy(response));
		}
		load();
	}, [ dateFrom, dateUntil ]);
	
	const customerRef = useRef(null);
	const overviewRef = useRef(null);
	useEffect(() => {
		if (paramPage == 'overview' && overviewRef !== null && overviewRef.current !== null) {
			overviewRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	}, [ paramPage ]);
	
	useEffect(() => {
		document.title = getTrans(trans, 'fe__header__title', paramLang);
	}, [ paramLang, trans ]);
	
	const floatingNextIndexRef = useRef(null);
	const floatingNextOverviewRef = useRef(null);
	
	// causes rerender, which is important because of calculating floating-next container height
	const screen_size = useWindowSize(100);
	const [ floatingNextHeight, setFloatingNextHeight ] = useState(0);
	
	const calculateFloatingNextHeight = () => {
		if (paramPage == 'index') {
			if (cart.length == 0 || floatingNextIndexRef.current === null) return 0;
			return floatingNextIndexRef.current.offsetHeight;
		}
		else if (paramPage == 'overview') {
			if (floatingNextOverviewRef.current === null) return 0;
			return floatingNextOverviewRef.current.offsetHeight;
		}
		return 0;
	};
	
	useEffect(() => {
		setTimeout(() => setFloatingNextHeight(calculateFloatingNextHeight()), 1000);
	}, [ paramPage, screen_size, floatingNextIndexRef, cart ]);
	
	// since we're returning here, there must not be any hooks after this point
	if (accommodations === null || countries === null) {
		return 'loading';
	}
	
	const pages = {
		'index': () => {
			let accommodation_components = null;
			if (paramDateFrom !== null && paramDateUntil !== null && accommodations !== null) {
				accommodation_components =
					<AccommodationTypeGeneric
						trans={trans}
						type={paramAccommodationType}
						lang={paramLang}
						accommodations={accommodations}
						onConfirmItem={item => {
							setCart([ ...cart, { ...item, date_from: paramDateFrom, date_until: paramDateUntil, person_count: paramPersonCount } ]);
						}}
						prices={itemPrices}
						occupancy={accommodationOccupancy}
						cart={cart}
						date_from={paramDateFrom}
						date_until={paramDateUntil}
						personCount={paramPersonCount} />;
			}
			else {
				accommodation_components = <div
					className='empty-state'
					style={{ backgroundImage: 'url("' + Logos[CLIENT] + '")' }} />;
			}
			
			return <>
				<div className='main-selector'>
					<div className='main-selector-inner'>
						{accommodations === null || Object.keys(accommodations).length <= 1 ? null : <div className='accommodation-selector'>
							<div className='accommodation-selector-title'>{ getTrans(trans, 'fe__main_selector__accommodation_type', paramLang) }</div>
							<AccommodationTypeSelector
								trans={trans}
								lang={paramLang}
								value={paramAccommodationType}
								setValue={setAccommodationType}
								accommodations={accommodations} />
						</div>}
						<div>
							<div className='person-counts-title'>{ getTrans(trans, 'fe__main_selector__person_count', paramLang) }</div>
							<div className='person-counts'>
								{[
									{ title: getTrans(trans, 'fe__main_selector__person_adult', paramLang),   key: 'adult',   min: 1 },
									{ title: getTrans(trans, 'fe__main_selector__person_child_2', paramLang), key: 'child_2', min: 0 },
									{ title: getTrans(trans, 'fe__main_selector__person_child_1', paramLang), key: 'child_1', min: 0 },
								].map((item, idx) =>
									<div className='person-count' key={'person-count-' + idx}>
										<div className='person-count-input'>
											<button className='person-count-input-neg' disabled={paramPersonCount[item.key] == item.min} onClick={() => {
												const new_counts = {...paramPersonCount};
												new_counts[item.key] = Math.max(item.min, new_counts[item.key] - 1);
												setPersonCount(new_counts);
											}}>-</button>
											<div className='person-count-input-number'>{ paramPersonCount[item.key] }</div>
											<button className='person-count-input-pos' onClick={() => {
												const new_counts = {...paramPersonCount};
												new_counts[item.key]++; //TODO upper limit?
												setPersonCount(new_counts);
											}}>+</button>
										</div>
										<div className='person-count-title'>{ item.title }</div>
									</div>
								)}
							</div>
						</div>
						<div className='date-selector'>
							<div className='date-selector-title'>{ getTrans(trans, 'fe__main_selector__date_range', paramLang) }</div>
							<div>
								{accommodations === null ? null :
									<DateRange
										trans={trans}
										lang={paramLang}
										disabled={paramAccommodationType === null}
										dateFrom={paramDateFrom}
										dateUntil={paramDateUntil}
										setDateRange={setDateRange}
										accommodations={accommodations[paramAccommodationType]} />
								}
							</div>
						</div>
					</div>
				</div>
				<div>
					{accommodation_components}
				</div>
				<div className={ 'floating-next floating-next-index ' + (cart.length == 0 ? 'hidden' : '') } ref={floatingNextIndexRef}>
					<div>
						<div className='cart-title'>{ getTrans(trans, 'fe__bottom_bar__current_selection', paramLang) }</div>
						<div className='cart'>
							{cart.map((item, idx) => {
								const item_item = itemsByIds[item.id_item];
								if (item_item === undefined) return null;
								
								return <React.Fragment key={'cart-item-' + idx}>
									<div className='large-gap'>{ item_item.title[paramLang] }</div>
									<div className='large-gap'>{
										getTrans(trans, 'fe__bottom_bar__cart__person_count', paramLang) +
										' ' +
										(item.person_count.adult + item.person_count.child_2 + item.person_count.child_1) +
										(
											[ item.person_count.adult, item.person_count.child_2, item.person_count.child_1 ]
												.filter(x => x > 0)
												.length <= 1
													? ''
													: (
														' (' +
														[ item.person_count.adult, item.person_count.child_2, item.person_count.child_1 ]
															.filter(x => x > 0)
															.join(' + ') +
														')'
													)
										)
									}</div>
									<div className='small-gap'>{ item.date_from.toLocaleDateString() + ' - ' + item.date_until.toLocaleDateString() }</div>
									<button
										className='button remove-button'
										onClick={() => {
											const new_cart = [ ...cart ];
											new_cart.splice(idx, 1);
											setCart(new_cart);
										}} />
									{item_item.additional_services.length == 0
										? <div />
										: <button
											className='button edit-button'
											onClick={() => {
												setCartEditSelectedItem(idx);
											}} />
									}
								</React.Fragment>;
							})}
						</div>
						<div className='cart-mobile'>
							{cart.map((item, idx) => {
								const item_item = itemsByIds[item.id_item];
								if (item_item === undefined) return null;
								
								return <React.Fragment key={'cart-item-' + idx}>
									<div className='cart-mobile-part-1'>
										<div className='large-gap flex-1'>{ item_item.title[paramLang] }</div>
										<button
											className='button remove-button'
											onClick={() => {
												const new_cart = [ ...cart ];
												new_cart.splice(idx, 1);
												setCart(new_cart);
											}} />
										{item_item.additional_services.length == 0
											? <div />
											: <button
												className='button edit-button'
												onClick={() => {
													setCartEditSelectedItem(idx);
												}} />
										}
									</div>
									<div className='cart-mobile-part-2'>
										<div className='large-gap flex-1'>{
											getTrans(trans, 'fe__bottom_bar__cart__person_count', paramLang) +
											' ' +
											(item.person_count.adult + item.person_count.child_2 + item.person_count.child_1) +
											(
												[ item.person_count.adult, item.person_count.child_2, item.person_count.child_1 ]
													.filter(x => x > 0)
													.length <= 1
														? ''
														: (
															' (' +
															[ item.person_count.adult, item.person_count.child_2, item.person_count.child_1 ]
																.filter(x => x > 0)
																.join(' + ') +
															')'
														)
											)
										}</div>
										<div>{ item.date_from.toLocaleDateString() + ' - ' + item.date_until.toLocaleDateString() }</div>
									</div>
								</React.Fragment>;
							})}
						</div>
					</div>
					<div className='cart-continue'>
						<span>{ getTrans(trans, 'fe__bottom_bar__continue_index_text', paramLang) }</span>
						<button className='button continue-button' onClick={() => setPage('overview')}>
							{ getTrans(trans, 'fe__bottom_bar__continue', paramLang) }
						</button>
					</div>
				</div>
			</>;
		},
		'overview': () =>
			<PageOverview
				trans                   ={trans}
				lang                    ={paramLang}
				accommodations          ={accommodations}
				countries               ={countries}
				cart                    ={cart}
				cart_with_prices        ={cartWithPrices}
				itemsByIds              ={itemsByIds}
				setPage                 ={page => setPage(page)}
				successDialogOpen       ={successDialogOpen}
				closeSuccessDialog      ={() => {
					setSuccessDialogOpen(false);
					if (!DEV_MODE) setCart([]);
					setPage('index');
				}}
				errorDialogOpen       ={errorDialogOpen}
				openErrorDialog       ={message => {
					setErrorDialogMessage(message);
					setErrorDialogOpen(true);
				}}
				closeErrorDialog      ={() => {
					setErrorDialogOpen(false);
				}}
				errorDialogMessage={errorDialogMessage}
				handleSaveReservationResult={() => {
					setSuccessDialogOpen(true);
				}}
				customer_name           ={customer_name}
				customer_surname        ={customer_surname}
				customer_email          ={customer_email}
				customer_email_again    ={customer_email_again}
				customer_id_country     ={customer_id_country}
				customer_phone          ={customer_phone}
				customer_address        ={customer_address}
				customer_post_code_name ={customer_post_code_name}
				customer_note           ={customer_note}
				customer_agree_1        ={customer_agree_1}
				customer_agree_2        ={customer_agree_2}
				setCustomerName         ={setCustomerName}
				setCustomerSurname      ={setCustomerSurname}
				setCustomerEmail        ={setCustomerEmail}
				setCustomerEmailAgain   ={setCustomerEmailAgain}
				setCustomerIdCountry    ={setCustomerIdCountry}
				setCustomerPhone        ={setCustomerPhone}
				setCustomerAddress      ={setCustomerAddress}
				setCustomerPostCodeName ={setCustomerPostCodeName}
				setCustomerNote         ={setCustomerNote}
				setCustomerAgree1       ={setCustomerAgree1}
				setCustomerAgree2       ={setCustomerAgree2}
				customerRef             ={customerRef}
				overviewRef             ={overviewRef}
				floatingNextOverviewRef ={floatingNextOverviewRef}
				floatingNextHeight      ={floatingNextHeight} />,
	};
	
	return <div
		className={ 'main-container main-container-' + paramPage }
		style={{ paddingBottom: floatingNextHeight }}>
		<div className='header'>
			<img className='logo' src={Logos[CLIENT]} />
			<div className='flex-1'></div>
			<div className='title'>
				<div>{ getTrans(trans, 'fe__header__title', paramLang) }</div>
				<div className='subtitle'>{ getTrans(trans, 'fe__header__subtitle', paramLang) }</div>
				{paramPage != 'index' ? null : <div className='subtitle'>{ getTrans(trans, 'fe__header__subsubtitle', paramLang) }</div>}
			</div>
			<div className='flex-1'></div>
			<div className='header-right'>
				<div className='countries'>
					<img
						className={ 'country ' + (paramLang == 'sl' ? 'active' : '') }
						src={new URL('/src/images/countries/slovenia.png', import.meta.url)}
						onClick={() => setLang('sl')} />
					<img
						className={ 'country ' + (paramLang == 'en' ? 'active' : '') }
						src={new URL('/src/images/countries/united-kingdom.png', import.meta.url)}
						onClick={() => setLang('en')} />
					<img
						className={ 'country ' + (paramLang == 'de' ? 'active' : '') }
						src={new URL('/src/images/countries/germany.png', import.meta.url)}
						onClick={() => setLang('de')} />
				</div>
				<div className='flex-1'></div>
				<button className='button' onClick={() => setGroupDialogOpen(true)}>
					{ getTrans(trans, 'fe__header__group_button', paramLang) }
				</button>
			</div>
		</div>
		{pages[paramPage]()}
		
		<Modal
			className='large-info-modal'
			show={groupDialogOpen}
			onHide={() => setGroupDialogOpen(false)}
			renderBackdrop={() => <div className='large-info-modal-backdrop' onClick={() => setGroupDialogOpen(false)} />}>
			<div className='large-info-modal-wrapper'>
				<div className='large-info-modal-content'>
					<div dangerouslySetInnerHTML={{ __html: getTrans(trans, 'fe__header__group_content', paramLang) }}/>
				</div>
				<div className='large-info-modal-actions'>
					<button className='button primary-button' onClick={() => setGroupDialogOpen(false)}>
						{ getTrans(trans, 'fe__error_dialog__close', paramLang) }
					</button>
				</div>
			</div>
		</Modal>
		
		{cartEditSelectedItem === null
			? null
			: <AccommodationDetailsDialog
					trans={trans}
					lang={paramLang}
					item={itemsByIds[cart[cartEditSelectedItem].id_item]}
					services={cart[cartEditSelectedItem].services}
					additional_services={cart[cartEditSelectedItem].additional_services}
					onCancel={() => setCartEditSelectedItem(null)}
					onConfirm={(services, additional_services) => {
						const new_cart = [ ...cart ];
						new_cart[cartEditSelectedItem] = {
							...new_cart[cartEditSelectedItem],
							services,
							additional_services,
						};
						setCart(new_cart);
						
						setCartEditSelectedItem(null);
					}} />
		}
	</div>;
}

function PageOverview(props) {
	const [ loading,       setLoading       ] = useState(false);
	const [ fieldFailures, setFieldFailures ] = useState([]);
	
	if (props.cart_with_prices.length != props.cart.length) {
		// something went wrong, but we're probably just loading
		return null;
	}
	
	const country_options =
		props.countries.map(x => { return { value: x.id_country, label: x.official_name_international }; });
	
	return <>
		<div className='overview-header' ref={props.overviewRef}>
			<div>{ getTrans(props.trans, 'fe__overview__title', props.lang) }</div>
		</div>
		<div className='overview'>
			<div className='overview-intro' dangerouslySetInnerHTML={{ __html: getTrans(props.trans, 'fe__overview__intro', props.lang) }} />
			
			<div className='desktop'>
				<OverviewDesktop
					trans={props.trans}
					lang={props.lang}
					cart={props.cart}
					itemsByIds={props.itemsByIds}
					cart_with_prices={props.cart_with_prices}
					accommodations={props.accommodations} />
			</div>
			<div className='mobile'>
				<OverviewMobile
					trans={props.trans}
					lang={props.lang}
					cart={props.cart}
					itemsByIds={props.itemsByIds}
					cart_with_prices={props.cart_with_prices}
					accommodations={props.accommodations} />
			</div>
		</div>
		
		<div className='customer' ref={props.customerRef}>
			<div className='customer-title'>{ getTrans(props.trans, 'fe__overview__customer__title', props.lang) }</div>
			
			<div className='customer-table'>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ getTrans(props.trans, 'fe__overview__customer__name', props.lang) }</div>
					<div className='customer-table-row-value'>
						<input
							type='text'
							name='first-name'
							className={fieldFailures.indexOf('customer_name') == -1 ? '' : 'error'}
							value={props.customer_name}
							onChange={event => props.setCustomerName(event.target.value)} />
					</div>
				</div>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ getTrans(props.trans, 'fe__overview__customer__surname', props.lang) }</div>
					<div className='customer-table-row-value'>
						<input
							type='text'
							name='last-name'
							className={fieldFailures.indexOf('customer_surname') == -1 ? '' : 'error'}
							value={props.customer_surname}
							onChange={event => props.setCustomerSurname(event.target.value)} />
					</div>
				</div>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ getTrans(props.trans, 'fe__overview__customer__email', props.lang) }</div>
					<div className='customer-table-row-value'>
						<input
							type='email'
							name='email'
							className={fieldFailures.indexOf('customer_email') == -1 ? '' : 'error'}
							value={props.customer_email.value}
							onChange={event => props.setCustomerEmail({ value: event.target.value, valid: event.target.validity.valid })} />
					</div>
				</div>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ getTrans(props.trans, 'fe__overview__customer__email_again', props.lang) }</div>
					<div className='customer-table-row-value'>
						<input
							type='email'
							className={
								props.customer_email.value.length > 0 && props.customer_email_again.value.length > 0 && props.customer_email.value != props.customer_email_again.value
									? 'error'
									: ''
							}
							value={props.customer_email_again.value}
							onChange={event => props.setCustomerEmailAgain({ value: event.target.value, valid: event.target.validity.valid })} />
					</div>
				</div>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ getTrans(props.trans, 'fe__overview__customer__country', props.lang) }</div>
					<div className={ 'customer-table-row-value ' + (fieldFailures.indexOf('customer_id_country') == -1 ? '' : 'error') }>
						<Select
							placeholder=''
							options={country_options}
							value={props.customer_id_country === null ? null : country_options.filter(x => x.value == props.customer_id_country)[0]}
							onChange={(new_value, action_meta) => {
								switch (action_meta.action) {
									case 'remove-value':
									case 'pop-value':
										if (action_meta.removedValue.isFixed) {
											return;
										}
										break;
									case 'clear':
										new_value = null;
										break;
								}
								
								const prev_customer_id_country = props.customer_id_country;
								
								props.setCustomerIdCountry(new_value === null ? '' : new_value.value);
								if (new_value !== null) {
									const prev_country = prev_customer_id_country == '' ? null : props.countries.filter(x => x.id_country == prev_customer_id_country)[0];
									const country      = props.countries.filter(x => x.id_country == new_value.value)[0];
									if (props.customer_phone == '' || props.customer_phone == ('+' + (prev_country === null ? '' : prev_country.calling_code))) {
										props.setCustomerPhone('+' + country.calling_code);
									}
								}
							}} />
					</div>
				</div>
				<div className='customer-table-row'>
					<div className='customer-table-row-title'>{ getTrans(props.trans, 'fe__overview__customer__phone', props.lang) }</div>
					<div className='customer-table-row-value'>
						<input
							type='text'
							name='phone'
							className={fieldFailures.indexOf('customer_phone') == -1 ? '' : 'error'}
							value={props.customer_phone}
							onChange={event => props.setCustomerPhone(event.target.value)} />
					</div>
				</div>
				{[ 'ptoni', 'ktoni', 'ptoni_test', 'ktoni_test', 'test' ].indexOf(CLIENT) > -1 ? null : <div className='customer-table-row'>
					<div className='customer-table-row-title'>{ getTrans(props.trans, 'fe__overview__customer__address', props.lang) }</div>
					<div className='customer-table-row-value'>
						<input
							type='text'
							name='address'
							className={fieldFailures.indexOf('customer_address') == -1 ? '' : 'error'}
							value={props.customer_address}
							onChange={event => props.setCustomerAddress(event.target.value)} />
					</div>
				</div>}
				{[ 'ptoni', 'ktoni', 'ptoni_test', 'ktoni_test', 'test' ].indexOf(CLIENT) > -1 ? null : <div className='customer-table-row'>
					<div className='customer-table-row-title'>{ getTrans(props.trans, 'fe__overview__customer__post_office', props.lang) }</div>
					<div className='customer-table-row-value'>
						<input
							type='text'
							name='post-code'
							className={fieldFailures.indexOf('customer_post_code_name') == -1 ? '' : 'error'}
							value={props.customer_post_code_name}
							onChange={event => props.setCustomerPostCodeName(event.target.value)} />
					</div>
				</div>}
				<div className='customer-table-row span-2'>
					<div className='customer-table-row-title' dangerouslySetInnerHTML={{ __html: getTrans(props.trans, 'fe__overview__customer__note', props.lang) }} />
					<div className='customer-table-row-value'>
						<textarea
							className={fieldFailures.indexOf('customer_note') == -1 ? '' : 'error'}
							value={props.customer_note}
							onChange={event => props.setCustomerNote(event.target.value)} />
					</div>
				</div>
				<div className={ 'customer-table-row span-2 ' + (fieldFailures.indexOf('customer_agree_1') == -1 ? '' : 'error') }>
					<input type='checkbox' id='customer-agree-1' checked={props.customer_agree_1} onChange={e => props.setCustomerAgree1(e.target.checked) } />
					<label htmlFor='customer-agree-1' dangerouslySetInnerHTML={{ __html: getTrans(props.trans, 'fe__overview__customer__agree_1', props.lang) }} />
				</div>
				<div className='customer-table-row span-2'>
					<input type='checkbox' id='customer-agree-2' checked={props.customer_agree_2} onChange={e => props.setCustomerAgree2(e.target.checked) } />
					<label htmlFor='customer-agree-2' dangerouslySetInnerHTML={{ __html: getTrans(props.trans, 'fe__overview__customer__agree_2', props.lang) }} />
				</div>
			</div>
		</div>
		<div className={ 'floating-next floating-next-overview' } ref={props.floatingNextOverviewRef}>
			<div>
				<button className='button back-button' onClick={() => props.setPage('index')}>{ getTrans(props.trans, 'fe__bottom_bar__back', props.lang) }</button>
			</div>
			<div>
				<button
					disabled={loading}
					className={ 'button continue-button ' + (loading ? 'saving' : '') }
					onClick={async () => {
						const skip_address = [ 'ptoni', 'ktoni', 'ptoni_test', 'ktoni_test', 'test' ].indexOf(CLIENT) > -1;
						
						const field_validations = {
							customer_name:           props.customer_name             .length > 0,
							customer_surname:        props.customer_surname          .length > 0,
							customer_email:          props.customer_email.value      .length > 0,
							customer_email_again:    props.customer_email_again.value.length > 0,
							customer_phone:          props.customer_phone            .length > 0,
							customer_address:        props.customer_address          .length > 0 || skip_address,
							customer_post_code_name: props.customer_post_code_name   .length > 0 || skip_address,
							customer_id_country:     props.customer_id_country !== null && props.customer_id_country.length > 0,
							customer_agree_1:        props.customer_agree_1 === true,
						};
						const field_failures = Object.keys(field_validations).filter(field => !field_validations[field]);
						setFieldFailures(field_failures);
						
						let error_message = null;
						if (props.cart.length == 0) {
							error_message = getTrans(props.trans, 'fe__error_dialog__validation_messages__empty_cart', props.lang);
						}
						else if (field_failures.length > 0) {
							error_message = getTrans(props.trans, 'fe__error_dialog__validation_messages__required_fields', props.lang);
						}
						else if (!props.customer_email.valid) {
							error_message = getTrans(props.trans, 'fe__error_dialog__validation_messages__invalid_email', props.lang);
						}
						else if (props.customer_email.value != props.customer_email_again.value) {
							error_message = getTrans(props.trans, 'fe__error_dialog__validation_messages__emails_not_match', props.lang);
						}
						
						if (error_message !== null) {
							props.openErrorDialog(error_message);
							props.customerRef.current.scrollIntoView({ behavior: 'smooth' });
							return;
						}
						
						setLoading(true);
						const response = await saveReservation(
							BASE_URL,
							props.lang,
							props.cart.map(x => {
								return {
									id_item:             x.id_item,
									date_from:           x.date_from,
									date_until:          x.date_until,
									person_count:        x.person_count,
									services:            x.services,
									additional_services: x.additional_services,
								};
							}),
							props.customer_agree_1,
							props.customer_agree_2,
							props.customer_name,
							props.customer_surname,
							props.customer_email.value,
							props.customer_email_again.value,
							props.customer_id_country,
							props.customer_phone,
							props.customer_address,
							props.customer_post_code_name,
							props.customer_note
						);
						setLoading(false);
						
						if (response.success === true) {
							props.handleSaveReservationResult();
						}
						else {
							switch (response.error ?? '') {
								case 'occupied':
									props.openErrorDialog(getTrans(props.trans, 'fe__error_dialog__occupied', props.lang).replaceAll(
										'{reservations}',
										'<div class="occupied-errors">' +
											response.occupied_reservations.map(r =>
												'<div>' + props.itemsByIds[r.id_item].title[props.lang] + '</div>' +
												'<div>' +
													getTrans(props.trans, 'fe__bottom_bar__cart__person_count', props.lang) + ' ' +
													(r.person_count.adult + r.person_count.child_1 + r.person_count.child_2) +
												'</div>' +
												'<div class="text-right">' + new Date(r.date_from).toLocaleDateString() + ' - ' + new Date(r.date_until).toLocaleDateString() + '</div>'
											).join('') +
										'</div>'
									));
									
									break;
								case 'validation_failed':
								default:
									props.openErrorDialog(getTrans(props.trans, 'fe__error_dialog__error_from_server', props.lang));
							}
						}
					}}>
					{ getTrans(props.trans, 'fe__bottom_bar__confirm', props.lang) }
					<div className='loader'></div>
				</button>
			</div>
		</div>
		
		<Modal
			className='confirmation-modal'
			show={props.successDialogOpen}
			onHide={props.closeSuccessDialog}
			renderBackdrop={() => <div className='confirmation-modal-backdrop' />}>
			<div>
				<div className='confirmation-modal-content'>
					<div dangerouslySetInnerHTML={{ __html: getTrans(props.trans, 'fe__success_dialog__title', props.lang) }} />
					<div><img src={new URL('/src/images/check-circle-outline.svg', import.meta.url)} /></div>
					<div>
						<button
							className='button'
							onClick={props.closeSuccessDialog}>
							{ getTrans(props.trans, 'fe__success_dialog__close', props.lang) }
						</button>
					</div>
				</div>
			</div>
		</Modal>
		
		<Modal
			className='error-modal'
			show={props.errorDialogOpen}
			onHide={props.closeErrorDialog}
			renderBackdrop={() => <div className='error-modal-backdrop' />}>
			<div>
				<div className='error-modal-content'>
					<div className='error-modal-content-title'>{ getTrans(props.trans, 'fe__error_dialog__title', props.lang) }</div>
					<div dangerouslySetInnerHTML={{ __html: props.errorDialogMessage }} />
					<div><img src={new URL('/src/images/alert-circle-outline.svg', import.meta.url)} /></div>
					<div>
						<button
							className='button'
							onClick={props.closeErrorDialog}>
							{ getTrans(props.trans, 'fe__error_dialog__close', props.lang) }
						</button>
					</div>
				</div>
			</div>
		</Modal>
	</>;
}

function OverviewDesktop(props) {
	const { total_amount, prepayment_amount } = calculateCartAmount(props.cart, props.cart_with_prices, props.accommodations, props.itemsByIds);
	
	return <div className='overview-table'>
		<div className='overview-table-row-header'>{ getTrans(props.trans, 'fe__overview__table__service', props.lang) }</div>
		<div className='overview-table-row-header'>{ getTrans(props.trans, 'fe__overview__table__date_range', props.lang) }</div>
		<div className='overview-table-row-header text-right'>{ getTrans(props.trans, 'fe__overview__table__day_count', props.lang) }</div>
		<div className='overview-table-row-header text-right'>{ getTrans(props.trans, 'fe__overview__table__quantity', props.lang) }</div>
		<div className='overview-table-row-header text-right'>{ getTrans(props.trans, 'fe__overview__table__price_item', props.lang) }</div>
		<div className='overview-table-row-header text-right'>{ getTrans(props.trans, 'fe__overview__table__price', props.lang) }</div>
		
		{props.cart.map((item, idx) => {
			let items = [];
			const item_item = props.itemsByIds[item.id_item];
			if (item_item !== undefined) {
				const adult_prices   = [];
				const child_1_prices = [];
				const child_2_prices = [];
				
				let child_1_count = 0;
				let child_2_count = 0;
				
				for (let price_key in props.cart_with_prices[idx].prices.main) {
					for (let date_key in props.cart_with_prices[idx].prices.main[price_key]) {
						const price_item = props.cart_with_prices[idx].prices.main[price_key][date_key];
						
						child_1_count += price_item.person_count_child_1;
						child_2_count += price_item.person_count_child_2;
						
						if (price_item.person_count_adult > 0) {
							adult_prices.push(price_item);
						}
						else if (price_item.person_count_child_1 > 0) {
							child_1_prices.push(price_item);
						}
						else {
							child_2_prices.push(price_item);
						}
					}
				}
				
				const addSubPriceItem = (type, price_item_idx, title, count, item_idx) => {
					if (count == 0) return;
					
					items.push(<React.Fragment key={'cart-item-' + idx + '-' + type + '-' + price_item_idx + '-subitem-' + item_idx}>
						<div className='overview-table-row service span-2 pl-1'>{ title + ': ' + count }</div>
						<div className='overview-table-row service text-right'></div>
						<div className='overview-table-row service text-right'></div>
						<div className='overview-table-row service text-right'></div>
						<div className='overview-table-row service text-right'></div>
					</React.Fragment>);
				};
				
				[
					[ adult_prices,   'adult'   ],
					[ child_2_prices, 'child_2' ],
					[ child_1_prices, 'child_1' ],
				].forEach(prices_item => {
					prices_item[0].forEach((price_item, price_item_idx) => {
						items.push(
							<React.Fragment key={'cart-item-' + idx + '-' + prices_item[1] + '-' + price_item_idx}>
								<div className='overview-table-row'>{ item_item.title[props.lang] }</div>
								<div className='overview-table-row'>{
									new Date(price_item.min_date + 'T12:00:00').toLocaleDateString() +
									' - ' +
									toDate(addDays(price_item.max_date + 'T12:00:00', 1)).toLocaleDateString()
								}</div>
								<div className='overview-table-row text-right'>{ formatNumber(price_item.day_count, 0) }</div>
								<div className='overview-table-row text-right'>{ formatNumber(price_item.person_count, 0) }</div>
								<div className='overview-table-row text-right main-item'>{ formatNumber(price_item.price_item, 2) }</div>
								<div className='overview-table-row text-right main'>{ formatNumber(price_item.price, 2) }</div>
							</React.Fragment>
						);
						
						[
							[ getTrans(props.trans, 'fe__overview__table__person_adult', props.lang),   'person_count_adult'   ],
							[ getTrans(props.trans, 'fe__overview__table__person_child_2', props.lang), 'person_count_child_2' ],
							[ getTrans(props.trans, 'fe__overview__table__person_child_1', props.lang), 'person_count_child_1' ],
						].forEach((item, item_idx) => {
							addSubPriceItem(prices_item[1], price_item_idx, item[0], price_item[item[1]], item_idx);
						});
						
						if (price_item.surcharge_price > 0) {
							items.push(
								<React.Fragment key={'cart-item-' + idx + '-' + prices_item[1] + '-' + price_item_idx + '-surcharge'}>
									<div className='overview-table-row without-spacing'>{
										price_item.surcharge_type == 'D1'
											? getTrans(props.trans, 'fe__overview__table__surcharge_d1', props.lang)
											: (price_item.surcharge_type == 'D2'
												? getTrans(props.trans, 'fe__overview__table__surcharge_d2', props.lang)
												: ''
											)
									}</div>
									<div className='overview-table-row without-spacing'>{
										new Date(price_item.min_date + 'T12:00:00').toLocaleDateString() +
										' - ' +
										toDate(addDays(price_item.max_date + 'T12:00:00', 1)).toLocaleDateString()
									}</div>
									<div className='overview-table-row without-spacing text-right'></div>
									<div className='overview-table-row without-spacing text-right'></div>
									<div className='overview-table-row without-spacing text-right main-item'></div>
									<div className='overview-table-row without-spacing text-right main'>{ formatNumber(price_item.surcharge_price, 2) }</div>
								</React.Fragment>
							);
						}
					});
				});
			}
			
			overviewAddServices(items, item, props.itemsByIds, props.lang, true);
			overviewAddAdditionalServices(props.trans, items, item, idx, props.cart_with_prices, props.itemsByIds, props.lang, false);
			
			return items;
		})}
		
		<div className='overview-table-row-total span-5'>{ getTrans(props.trans, 'fe__overview__table__total', props.lang) }</div>
		<div className='overview-table-row-total text-right'>{
			formatNumber(total_amount, 2) + ' €'
		}</div>
		
		<div className='overview-table-row span-6 note' dangerouslySetInnerHTML={{ __html: getTrans(props.trans, 'fe__overview__tourist_tax', props.lang) }} />
		
		{prepayment_amount == 0 ? null : <>
			<div className='overview-table-row text-bold span-5'>{ getTrans(props.trans, 'fe__overview__prepayment_title', props.lang) }</div>
			<div className='overview-table-row text-bold text-right'>{
				formatNumber(prepayment_amount, 2) + ' €'
			}</div>
			
			<div className='overview-table-row span-6 note warning-border' dangerouslySetInnerHTML={{ __html: getTrans(props.trans, 'fe__overview__prepayment_description', props.lang) }} />
		</>}
	</div>;
}
function overviewAddServices(items, item, itemsByIds, lang, inline) {
	const service_keys = Object.keys(item.services ?? {})
		.filter(key => {
			const item_item = itemsByIds[item.id_item];
			if (item_item === undefined) return false;
			return item_item.services.filter(x => x.key == key).length > 0;
		});
	if (service_keys.length > 0) {
		items.push(<div key='services' className='overview-table-row span-full service pl-1' dangerouslySetInnerHTML={{ __html:
			service_keys.map((key, service_idx) => {
				const item_item = itemsByIds[item.id_item];
				if (item_item === undefined) return null;
				
				const service = item_item.services.filter(x => x.key == key)[0];
				
				let val = null;
				if (service.type == 'bool') {
					if (!item.services[key]) return null;
				}
				else if (service.type == 'count') {
					val = item.services[key] ?? 0;
					if (val == 0) return null;
				}
				else if (service.type == 'counts') {
					const vals = service.values.filter(val => item.services[key][val.key] !== undefined);
					if (vals.length == 0) return null;
					val = vals.map(val =>
						val.title[lang] + ': <span class=\'strong\'>' + item.services[key][val.key] + '</span>'
					).join(', ');
				}
				
				return service.title[lang] + (val === null ? '' : (': <span class=\'strong\'>' + val + '</span>'));
			}).filter(x => x !== null).join(inline ? ' <strong>•</strong> ' : '<br />')
		}} />);
	}
}
function overviewAddAdditionalServices(trans, items, item, idx, cart_with_prices, itemsByIds, lang, narrow_mode) {
	const fn = (key, service, service_idx, type) => {
		let val = null;
		if (service.type == 'bool') {
			if (!item[type][key]) return null;
		}
		else if (service.type == 'count') {
			val = item[type][key] ?? 0;
			if (val == 0) return null;
		}
		else if (service.type == 'counts') {
			const vals = service.values.filter(val => item[type][key][val.key] !== undefined);
			if (vals.length == 0) return null;
			val = vals.map(val =>
				val.title[lang] + ': ' + item[type][key][val.key]
			).join(', ');
		}
		
		const items = [];
		for (let price_key in cart_with_prices[idx].prices[type][key].main) {
			for (let date_key in cart_with_prices[idx].prices[type][key].main[price_key]) {
				if (narrow_mode) {
					items.push(<React.Fragment key={'cart-item-' + type + '-' + service_idx + '-' + price_key + '-' + date_key}>
						<div className='overview-table-row service pl-1'>
							<span>{ service.title[lang] }</span>
							<em>{
								': ' +
								formatNumber(cart_with_prices[idx].prices[type][key].main[price_key][date_key].day_count, 0) +
								' x ' +
								formatNumber(cart_with_prices[idx].prices[type][key].main[price_key][date_key].person_count * val, 0) +
								' ' + getTrans(trans, 'fe__overview__table__days', lang)
							}</em>
						</div>
						<div className='overview-table-row service text-right'>{ formatNumber(cart_with_prices[idx].prices[type][key].main[price_key][date_key].price, 2) }</div>
					</React.Fragment>);
				}
				else {
					items.push(<React.Fragment key={'cart-item-' + type + '-' + service_idx + '-' + price_key + '-' + date_key}>
						<div className='overview-table-row service span-2 pl-1'>{ service.title[lang] }</div>
						<div className='overview-table-row service text-right'>{ formatNumber(cart_with_prices[idx].prices[type][key].main[price_key][date_key].day_count, 0) }</div>
						<div className='overview-table-row service text-right'>{ formatNumber(cart_with_prices[idx].prices[type][key].main[price_key][date_key].person_count * val, 0) }</div>
						<div className='overview-table-row service text-right'>{ formatNumber(cart_with_prices[idx].prices[type][key].main[price_key][date_key].price_item, 2) }</div>
						<div className='overview-table-row service text-right'>{ formatNumber(cart_with_prices[idx].prices[type][key].main[price_key][date_key].price, 2) }</div>
					</React.Fragment>);
				}
			}
		}
		return items;
	};
	
	Object.keys(item.additional_services ?? {}).forEach((key, service_idx) => {
		const item_item = itemsByIds[item.id_item];
		if (item_item === undefined) return;
		
		const arr = item_item.additional_services.filter(x => x.key == key);
		if (arr.length == 0) return null;
		
		const service = arr[0];
		
		const new_items = fn(key, service, service_idx, 'additional_services');
		if (new_items !== null) new_items.forEach(x => items.push(x));
	});
}
function calculateCartAmount(cart, cart_with_prices, accommodations, itemsByIds) {
	let total_amount      = 0;
	let prepayment_amount = 0;
	cart.forEach((item, idx) => {
		const item_by_id = itemsByIds[cart_with_prices[idx].id_item];
		if (item_by_id === undefined) return;
		
		const accommodation = accommodations[item_by_id.id_public_accommodation_group];
		if (accommodation === undefined) return;
		
		const group = accommodation.accommodation_group;
		
		for (let price_key in cart_with_prices[idx].prices.main) {
			for (let date_key in cart_with_prices[idx].prices.main[price_key]) {
				const price =
					cart_with_prices[idx].prices.main[price_key][date_key].price +
					cart_with_prices[idx].prices.main[price_key][date_key].surcharge_price;
				
				total_amount      += price;
				prepayment_amount += (group.prepayment_percent / 100) * price;
			}
		}
		
		Object.keys(item.additional_services ?? {}).forEach((key, service_idx) => {
			for (let price_key in cart_with_prices[idx].prices.additional_services[key].main) {
				for (let date_key in cart_with_prices[idx].prices.additional_services[key].main[price_key]) {
					const price = cart_with_prices[idx].prices.additional_services[key].main[price_key][date_key].price;
					
					total_amount      += price;
					prepayment_amount += (group.prepayment_percent / 100) * price;
				}
			}
		});
	});
	
	return { total_amount, prepayment_amount };
}
function OverviewMobile(props) {
	const { total_amount, prepayment_amount } = calculateCartAmount(props.cart, props.cart_with_prices, props.accommodations, props.itemsByIds);
	
	return <div className='overview-table-mobile'>
		<div className='overview-table-row-header'>{ getTrans(props.trans, 'fe__overview__table__service', props.lang) }</div>
		<div className='overview-table-row-header text-right'>{ getTrans(props.trans, 'fe__overview__table__price', props.lang) }</div>
		
		{props.cart.map((item, idx) => {
			let items = [];
			const item_item = props.itemsByIds[item.id_item];
			if (item_item !== undefined) {
				const adult_prices   = [];
				const child_1_prices = [];
				const child_2_prices = [];
				
				let child_1_count = 0;
				let child_2_count = 0;
				
				for (let price_key in props.cart_with_prices[idx].prices.main) {
					for (let date_key in props.cart_with_prices[idx].prices.main[price_key]) {
						const price_item = props.cart_with_prices[idx].prices.main[price_key][date_key];
						
						child_1_count += price_item.person_count_child_1;
						child_2_count += price_item.person_count_child_2;
						
						if (price_item.person_count_adult > 0) {
							adult_prices.push(price_item);
						}
						else if (price_item.person_count_child_1 > 0) {
							child_1_prices.push(price_item);
						}
						else {
							child_2_prices.push(price_item);
						}
					}
				}
				
				const addSubPriceItem = (type, price_item_idx, title, count, item_idx) => {
					if (count == 0) return;
					
					items.push(<React.Fragment key={'cart-item-' + idx + '-' + type + '-' + price_item_idx + '-subitem-' + item_idx}>
						<div className='overview-table-row service span-2 pl-05'>{ title + ': ' + count }</div>
					</React.Fragment>);
				};
				
				[
					[ adult_prices,   'adult'   ],
					[ child_2_prices, 'child_2' ],
					[ child_1_prices, 'child_1' ],
				].forEach(prices_item => {
					prices_item[0].forEach((price_item, price_item_idx) => {
						items.push(
							<React.Fragment key={'cart-item-' + idx + '-' + prices_item[1] + '-' + price_item_idx}>
								<div className='overview-table-row'>{ item_item.title[props.lang] }</div>
								<div className='overview-table-row text-right main'>{ formatNumber(price_item.price, 2) }</div>
								
								<div className='overview-table-row service span-2 pl-05'>{
									getTrans(props.trans, 'fe__overview__table__date_range', props.lang) + ': ' +
									new Date(price_item.min_date + 'T12:00:00').toLocaleDateString() +
									' - ' +
									toDate(addDays(price_item.max_date + 'T12:00:00', 1)).toLocaleDateString()
								}</div>
								
								<div className='overview-table-row service span-2 pl-05'>{
									getTrans(props.trans, 'fe__overview__table__day_count', props.lang) + ': ' +
									formatNumber(price_item.day_count, 0) +
									' • ' +
									getTrans(props.trans, 'fe__overview__table__quantity', props.lang) + ': ' +
									formatNumber(price_item.person_count, 0) +
									' • ' +
									getTrans(props.trans, 'fe__overview__table__price_item', props.lang) + ': ' +
									formatNumber(price_item.price_item, 2)
								}</div>
								
							</React.Fragment>
						);
						
						[
							[ getTrans(props.trans, 'fe__overview__table__person_adult', props.lang),   'person_count_adult'   ],
							[ getTrans(props.trans, 'fe__overview__table__person_child_2', props.lang), 'person_count_child_2' ],
							[ getTrans(props.trans, 'fe__overview__table__person_child_1', props.lang), 'person_count_child_1' ],
						].forEach((item, item_idx) => {
							addSubPriceItem(prices_item[1], price_item_idx, item[0], price_item[item[1]], item_idx);
						});
						
						if (price_item.surcharge_price > 0) {
							items.push(
								<React.Fragment key={'cart-item-' + idx + '-' + prices_item[1] + '-' + price_item_idx + '-surcharge'}>
									<div className='overview-table-row without-spacing'>{
										price_item.surcharge_type == 'D1'
											? getTrans(props.trans, 'fe__overview__table__surcharge_d1', props.lang)
											: (price_item.surcharge_type == 'D2'
												? getTrans(props.trans, 'fe__overview__table__surcharge_d2', props.lang)
												: ''
											)
									}</div>
									<div className='overview-table-row without-spacing text-right main'>{ formatNumber(price_item.surcharge_price, 2) }</div>
									
									<div className='overview-table-row service span-2 pl-05'>{
										getTrans(props.trans, 'fe__overview__table__date_range', props.lang) + ': ' +
										new Date(price_item.min_date + 'T12:00:00').toLocaleDateString() +
										' - ' +
										toDate(addDays(price_item.max_date + 'T12:00:00', 1)).toLocaleDateString()
									}</div>
								</React.Fragment>
							);
						}
					});
				});
			}
			
			overviewAddServices(items, item, props.itemsByIds, props.lang, false);
			overviewAddAdditionalServices(props.trans, items, item, idx, props.cart_with_prices, props.itemsByIds, props.lang, true);
			
			return items;
		})}
		
		<div className='overview-table-row-total'>{ getTrans(props.trans, 'fe__overview__table__total', props.lang) }</div>
		<div className='overview-table-row-total text-right'>{
			formatNumber(total_amount, 2) + ' €'
		}</div>
		
		<div className='overview-table-row span-2 note' dangerouslySetInnerHTML={{ __html: getTrans(props.trans, 'fe__overview__tourist_tax', props.lang) }} />
		
		{prepayment_amount == 0 ? null : <>
			<div className='overview-table-row text-bold'>{ getTrans(props.trans, 'fe__overview__prepayment_title', props.lang) }</div>
			<div className='overview-table-row text-bold text-right'>{
				formatNumber(prepayment_amount, 2) + ' €'
			}</div>
			
			<div className='overview-table-row span-2 note warning-border' dangerouslySetInnerHTML={{ __html: getTrans(props.trans, 'fe__overview__prepayment_description', props.lang) }} />
		</>}
	</div>;
}

function DateRange(props) {
	const [ open, setOpen ] = useState(false);
	
	const containerRef = useRef(null);
	const targetRef = useRef(null);
	
	const screen_size = useWindowSize(100);
	const screen_width = screen_size.width;
	
	const rangeIncludesReservedDays = range => {
		let c = 0;
		let d = range[0];
		while (true) {
			if (props.accommodations.reserved_by_days.indexOf(d) != -1) return true;
			
			d = dateToISO(new Date(new Date(d).getTime() + 24*60*60*1000));
			console.log({ d, end: range[1] });
			// stop when we get to last day (skip last day, since that is check out)
			if (d == range[1]) break;
			
			c++;
			if (c > 20) break;
		}
		return false;
	};
	
	return <div ref={containerRef} style={{ position: 'relative' }}>
		<button
			className='button date-selector-button'
			disabled={props.disabled}
			ref={targetRef}
			onClick={() => setOpen(!open)}>
			<div>{ props.dateFrom === null && props.dateUntil === null ? getTrans(props.trans, 'fe__main_selector__date_range_empty', props.lang) : (
				(props.dateFrom === null ? '' : props.dateFrom.toLocaleDateString()) +
				' - ' +
				(props.dateUntil === null ? '' : props.dateUntil.toLocaleDateString())
			)}</div>
			<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' style={{ width: 24, height: 24 }}><path style={{ fill: '#666666' }} d='M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z' /></svg>
		</button>
		<Modal
			className='calendar-modal'
			show={open}
			onHide={() => setOpen(false)}
			renderBackdrop={() => <div className='calendar-modal-backdrop' onClick={() => setOpen(false)} />}>
				<Calendar
					locale={props.lang}
					onChange={(val) => {
						console.log({ op: 'change', val });
						const date_iso_0 = dateToISO(val[0]);
						const date_iso_1 = dateToISO(val[1]);
						
						if (date_iso_0 != date_iso_1 && !rangeIncludesReservedDays([ date_iso_0, date_iso_1 ])) {
							props.setDateRange(
								val === null ? null : val[0],
								val === null ? null : val[1]
							);
							setOpen(false);
						}
					}}
					value={[ props.dateFrom, props.dateUntil ]}
					selectRange={true}
					showDoubleView={false}
					minDate={new Date()}
					maxDate={new Date(((new Date()).getFullYear() + 1) + '-12-31T12:00:00')}
					tileDisabled={({ date, view }) => {
						if (view == 'month') {
							const date_iso = dateToISO(date);
							//if (date_iso < '2024-08-24') return true;
							return props.accommodations.reserved_by_days.indexOf(date_iso) != -1;
						}
						return false;
					}} />
			</Modal>
	</div>;
	
	/*return <DateRangePicker onChange={(val) => {
		console.log({ val });
		setDateFrom (val === null ? null : val[0]);
		setDateUntil(val === null ? null : val[1]);
	}} value={[ dateFrom, dateUntil ]} />;*/
}

function AccommodationTypeSelector(props) {
	const colourStyles = {
		control: (styles) => ({ ...styles }),
		option: (styles, { data, isDisabled, isFocused, isSelected }) => {
			//const color = chroma(data.color);
			return {
				...styles,
				/*backgroundColor:
					isDisabled
					? undefined
					: isSelected
					? data.color
					: isFocused
					? color.alpha(0.1).css()
					: undefined,
				cursor: isDisabled ? 'not-allowed' : 'default',
				color:
					isDisabled
					? '#ccc'
					: isSelected
					? chroma.contrast(color, 'white') > 2
					? 'white'
					: 'black'
					: data.color,
				':active': {
					...styles[':active'],
					backgroundColor:
						!isDisabled
						? isSelected
						? data.color
						: color.alpha(0.3).css()
						: undefined,
				},*/
			};
		},
		input: (styles) => ({ ...styles }),
		placeholder: (styles) => ({ ...styles }),
		singleValue: (styles, { data }) => ({ ...styles }),
		groupHeading: (styles, { data }) => ({ ...styles, marginLeft: -20 }),
		group: (styles, { data }) => ({ ...styles, paddingLeft: 20 }),
	};
	
	const options = Object.keys(props.accommodations).map(id => ({
		label: props.accommodations[id].accommodation_group['title_' + props.lang],
		value: id,
	}));
	
	return <div style={{ display: 'flex', flexDirection: 'row' }}>
		{options.map((x, idx) =>
			<button
				key={'item-' + x.value}
				className={
					'button ' +
					(x.value === props.value ? 'selected' : '') + ' ' +
					(idx == 0 ? 'no-right-radius' : (idx == (options.length - 1) ? 'no-left-radius' : 'no-radius'))
				}
				style={{ whiteSpace: 'nowrap' }}
				onClick={() => props.setValue(x.value)}>
				{ x.label }
			</button>
		)}
	</div>;
}

function AccommodationTypeGeneric(props) {
	const { type } = props;
	
	const [ itemGalleryOpenIdx, setItemGalleryOpenIdx ] = useState(-1);
	const [ selectedItem,       setSelectedItem       ] = useState(null);
	const [ expanded,           setExpanded           ] = useState(false);
	
	const items = Object.values((props.accommodations[type] ?? {}).accommodation_items ?? []).map(item => {
		return { ...item, images: item.images.map(image => { return { src: image /*, width: 1920, height: 1326*/ }; }) };
	});
	
	useEffect(() => {
		if (itemGalleryOpenIdx == -1) return;
		
		let lightbox = new PhotoSwipeLightbox({
			dataSource: items[itemGalleryOpenIdx].images,
			pswpModule: PhotoSwipe,
		});
		
		lightbox.on('beforeOpen', () => {
			const pswp = lightbox.pswp;
			const ds = pswp.options.dataSource;
			if (Array.isArray(ds)) {
				for (let idx = 0, len = ds.length; idx < len; idx++) {
					const item = ds[idx];
					const img = new Image();
					img.onload = () => {
						item.width = img.naturalWidth;
						item.height = img.naturalHeight;
						pswp.refreshSlideContent(idx);
					};
					img.src = item.src;
				}
			}
		});
		lightbox.on('close', () => {
			setItemGalleryOpenIdx(-1);
		});
		
		lightbox.init();
		lightbox.loadAndOpen(0);
		
		return () => {
			lightbox.destroy();
			lightbox = null;
		};
	}, [ itemGalleryOpenIdx ]);
	
	const intro = props.accommodations[type].accommodation_group['intro_' + props.lang];
	
	return <div>
		<div className='accommodation-type-title'>{ props.accommodations[type].accommodation_group['title_' + props.lang] }</div>
		<div className='accommodation-type-description'>
			{intro.length == 0 ? null : <div className='mb-1' dangerouslySetInnerHTML={{ __html: intro }} />}
			<ul style={{ listStyle: 'disc inside' }} dangerouslySetInnerHTML={{ __html: props.accommodations[type].accommodation_group['description_1_' + props.lang] }} />
			<ul style={{ listStyle: 'disc inside', display: expanded ? 'block' : 'none' }} dangerouslySetInnerHTML={{ __html: props.accommodations[type].accommodation_group['description_2_' + props.lang] }} />
			<button
				className={'accommodation-type-description-expand ' + (expanded ? 'expanded' : '')}
				onClick={() => setExpanded(!expanded)}>
				<div className='accommodation-type-description-expand-icon'></div>
				<div className='accommodation-type-description-expand-text'>
					<span className='collapsed'>{ getTrans(props.trans, 'fe__accommodation_show_more', props.lang) }</span>
					<span className='expanded'>{ getTrans(props.trans, 'fe__accommodation_show_less', props.lang) }</span>
				</div>
			</button>
		</div>
		<div className='accommodation-items'>
			{items.map((item, idx) => {
				let found_in_cart = false;
				let occupied      = false;
				
				// we allow multiple entries for camp in cart (hence we're not checking found in cart)
				// and we check occupied by checking number of places needed (1 for each 4 people) vs number of places available
				if (props.accommodations[type].accommodation_group.type == 'camp') {
					let occupied_count = Math.ceil((props.personCount.adult + props.personCount.child_2 + props.personCount.child_1) / 4 /* we count 4 people per camp site */);
					
					for (let i=0; i<props.cart.length; i++) {
						if (props.cart[i].id_item != item.id) continue;
						
						if (
							dateToISO(props.cart[i].date_from) == dateToISO(props.date_from) &&
							dateToISO(props.cart[i].date_until) == dateToISO(props.date_until)
						) {
							occupied_count += Math.ceil(
								(props.cart[i].person_count.adult + props.cart[i].person_count.child_1 + props.cart[i].person_count.child_2) / 4 /* we count 4 people per camp site */
							);
						}
					}
					
					occupied = props.occupancy[type] === undefined ? false : (
						props.occupancy[type].accommodation_items[item.id] < occupied_count
					);
				}
				// for others, we check just that there are at least 1 available
				else {
					for (let i=0; i<props.cart.length; i++) {
						if (props.cart[i].id_item != item.id) continue;
						
						if (
							dateToISO(props.cart[i].date_from) == dateToISO(props.date_from) &&
							dateToISO(props.cart[i].date_until) == dateToISO(props.date_until)
						) {
							found_in_cart = true;
							break;
						}
					}
					
					occupied = props.occupancy[type] === undefined ? false : (props.occupancy[type].accommodation_items[item.id] == 0);
				}
				
				const selected = false;
				const max_people_exceeded = item.max_people_count != 0 && props.personCount.adult + props.personCount.child_2 + props.personCount.child_1 > item.max_people_count;
				
				return <AccommodationItem
					key={type + '-' + item.id}
					trans={props.trans}
					lang={props.lang}
					selected={selected}
					item={item}
					idx={idx}
					price={props.prices[item.id]}
					reserved={occupied}
					already_in_cart={found_in_cart}
					max_people_exceeded={max_people_exceeded}
					onItemSelect={() => {
						if (item.additional_services.length == 0) {
							props.onConfirmItem(
								{ type, id_item: item.id }
							);
						}
						else {
							setSelectedItem(item);
						}
					}}
					onImageClick={() => setItemGalleryOpenIdx(idx)} />;
			})}
			
			{selectedItem === null
				? null
				: <AccommodationDetailsDialog
					trans={props.trans}
					lang={props.lang}
					item={selectedItem}
					onCancel={() => setSelectedItem(null)}
					onConfirm={(services, additional_services) => {
						props.onConfirmItem(
							{ type, id_item: selectedItem.id, services, additional_services }
						);
						setSelectedItem(null);
					}} />
			}
		</div>
	</div>;
}

function AccommodationItem(props) {
	let cls = 'accommodation-item ';
	if (props.selected === true) {
		cls += 'selected ';
	}
	
	if (props.reserved === true) {
		cls += 'reserved ';
	}
	else if (props.already_in_cart === true) {
		cls += 'already-in-cart ';
	}
	else if (props.max_people_exceeded === true) {
		cls += 'max-people-exceeded ';
	}
	
	return <div
		className={cls}
		key={'item-' + props.item.id}
		style={{
			opacity: 0,
			animation: (props.reserved === true || props.already_in_cart === true || props.max_people_exceeded === true ? 'fadeInReserved' : 'fadeIn') + ` 500ms ease-out ${props.idx * 100}ms forwards`,
		}}>
		<div
			className='accommodation-item-image'
			style={
				props.item.image == ''
					? {}
					: { backgroundImage: 'url("' + props.item.image + '")' }
			}
			onClick={props.onImageClick}>
			<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M22,16V4A2,2 0 0,0 20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16M11,12L13.03,14.71L16,11L20,16H8M2,6V20A2,2 0 0,0 4,22H18V20H4V6' /></svg>
		</div>
		<div className='accommodation-item-first-line'>
			<div className='accommodation-item-title'><em>{ props.item.title[props.lang] }</em></div>
			<div
				className='accommodation-item-price-desc'
				dangerouslySetInnerHTML={{ __html: 
					props.item.price_desc[props.lang]
						.replaceAll('{price_child}', '<span class="price">' + (props.price === undefined ? '' : (formatNumber(props.price.child, 2) + ' €')) + '</span>')
						.replaceAll('{price_adult}', '<span class="price">' + (props.price === undefined ? '' : (formatNumber(props.price.adult, 2) + ' €')) + '</span>')
						.replaceAll('\\n', '<br />').replaceAll('\n', '<br />')
				}} />
		</div>
		<div className='accommodation-item-description' dangerouslySetInnerHTML={{
			__html: props.item.short_desc[props.lang].replaceAll('\n', '<br />').replaceAll('{space}', '<span style="padding-left: 1.5rem;"></span>')
		}} />
		<div className='accommodation-item-select'>
			<button
				onClick={props.onItemSelect}
				className='button primary-button'>
				{ getTrans(props.trans, 'fe__accommodation_item__choose', props.lang) }
			</button>
			<div className='occupied'>{ getTrans(props.trans, 'fe__accommodation_item__occupied', props.lang) }</div>
			<div className='in-cart'>{ getTrans(props.trans, 'fe__accommodation_item__in_cart', props.lang) }</div>
			<div className='max-people-exceeded'>{ getTrans(props.trans, 'fe__accommodation_item__max_people_exceeded', props.lang).replaceAll('{count}', props.item.max_people_count) }</div>
		</div>
	</div>;
}

function AccommodationDetailsDialogService(props) {
	if (props.service.type == 'bool') {
		return <div className={'service-dialog-service-wrapper ' + props.service.type}>
			<label htmlFor={ props.type + '-' + props.service.key } className={ props.type + '-title service-dialog-service-title ' + (props.invalid ? 'invalid' : '') }>
				{ props.service.title[props.lang] }
			</label>
			<div className={ 'service-dialog-service-value ' + props.type + '-value' }>
				<div className={ props.type + '-value-checkbox' }>
					<input
						id={ props.type + '-' + props.service.key }
						type='checkbox'
						checked={ props.services[props.service.key] }
						onChange={e => {
							const new_additional_services = { ...props.services };
							new_additional_services[props.service.key] = e.target.checked;
							props.onChange(new_additional_services);
						}} />
				</div>
			</div>
		</div>;
	}
	else if (props.service.type == 'count') {
		return <div className={'service-dialog-service-wrapper ' + props.service.type}>
			<label htmlFor={ props.type + '-' + props.service.key } className={ props.type + '-title service-dialog-service-title ' + (props.invalid ? 'invalid' : '') }>
				{ props.service.title[props.lang] + (props.service.required ? ' *' : '') }
			</label>
			<div className='service-dialog-service-value person-count'>
				<div className='person-count-input'>
					<button className='person-count-input-neg' disabled={(props.services[props.service.key] ?? 0) == 0} onClick={() => {
						const new_counts = { ...props.services };
						new_counts[props.service.key] = Math.max(0, (new_counts[props.service.key] ?? 0) - 1);
						if (new_counts[props.service.key] == 0) {
							delete new_counts[props.service.key];
						}
						props.onChange(new_counts);
					}}>-</button>
					<div className='person-count-input-number'>{ props.services[props.service.key] ?? 0 }</div>
					<button className='person-count-input-pos' onClick={() => {
						const new_counts = { ...props.services };
						new_counts[props.service.key] = (new_counts[props.service.key] ?? 0) + 1; //TODO upper limit?
						props.onChange(new_counts);
					}}>+</button>
				</div>
			</div>
		</div>;
	}
	else if (props.service.type == 'counts') {
		return <div className={'service-dialog-service-wrapper ' + props.service.type}>
			<div className={ props.type + '-title service-dialog-service-title ' + (props.invalid ? 'invalid' : '') }>
				{ props.service.title[props.lang] + (props.service.required ? ' *' : '') }
			</div>
			<div className='service-dialog-service-value person-counts'>
				{props.service.values.map(val => { return { title: val.title[props.lang], key: val.key, min: 0, img: val.img }; }).map((item, idx) => {
					const img = service_images[item.img] || null;
					
					return <div className={'person-count ' + (img === null ? 'mb-0' : '')} key={'person-count-' + idx}>
						<div className='person-count-input'>
							<button className='person-count-input-neg' disabled={(props.services[props.service.key][item.key] ?? 0) == item.min} onClick={() => {
								const new_counts = { ...props.services };
								new_counts[props.service.key][item.key] = Math.max(item.min, (new_counts[props.service.key][item.key] ?? 0) - 1);
								if (new_counts[props.service.key][item.key] == 0) {
									delete new_counts[props.service.key][item.key];
								}
								props.onChange(new_counts);
							}}>-</button>
							<div className='person-count-input-number'>{ props.services[props.service.key][item.key] ?? 0 }</div>
							<button className='person-count-input-pos' onClick={() => {
								const new_counts = { ...props.services };
								new_counts[props.service.key][item.key] = (new_counts[props.service.key][item.key] ?? 0) + 1; //TODO upper limit?
								props.onChange(new_counts);
							}}>+</button>
						</div>
						<div className='person-count-title'>{ item.title }</div>
						{img === null ? null : <div><img src={img} /></div>}
					</div>
				})}
			</div>
		</div>;
	}
	return null;
}

function AccommodationDetailsDialog(props) {
	const [ services, setServices ] = useState(props.services !== undefined ? props.services : (() => {
		const val = {};
		props.item.services.forEach(x => {
			if (x.type == 'counts') {
				val[x.key] = {};
			}
			else if (x.type == 'bool') {
				val[x.key] = false;
			}
			else {
				val[x.key] = null;
			}
		});
		return val;
	})());
	const [ additionalServices, setAdditionalServices ] = useState(props.additional_services !== undefined ? props.additional_services : (() => {
		const val = {};
		props.item.additional_services.forEach(x => {
			if (x.type == 'counts') {
				val[x.key] = {};
			}
			else if (x.type == 'bool') {
				val[x.key] = false;
			}
			else {
				val[x.key] = null;
			}
		});
		return val;
	})());
	const [ invalidServices,           setInvalidServices           ] = useState([]);
	const [ invalidAdditionalServices, setInvalidAdditionalServices ] = useState([]);
	const [ invalidGroupedServices,    setInvalidGroupedServices    ] = useState([]);
	const [ markInvalidServices,       setMarkInvalidServices       ] = useState(true);
	
	const isServiceInvalid = (service, val, require_bools) => {
		if (service.type == 'count') {
			if ((val ?? 0) == 0) {
				return true;
			}
		}
		else if (service.type == 'counts') {
			let count = 0;
			for (let key in val) {
				count += val[key];
			}
			if (count == 0) {
				return true;
			}
		}
		else if (require_bools && service.type == 'bool') {
			if ((val ?? 0) == 0) {
				return true;
			}
		}
		return false;
	};
	const findInvalidServices = (all_services, services) => all_services
		.filter(service => service.required)
		.filter(service => isServiceInvalid(service, services[service.key], false))
		.map(service => service.key);
	const findInvalidGroupServices = (all_services, services) => {
		let invalid_services = [];
		
		const grouped = {};
		for (let i=0; i<all_services.length; i++) {
			const group    = all_services[i]['group'] ?? null;
			const required = all_services[i]['required-group'] ?? false;
			if (group === null || !required) continue;
			
			if (grouped[group] === undefined) grouped[group] = [];
			grouped[group].push(all_services[i]);
		}
		
		const invalid_groups = Object.keys(grouped)
			.filter(group => {
				let valid = false;
				for (let i=0; i<grouped[group].length; i++) {
					const invalid = isServiceInvalid(grouped[group][i], services[grouped[group][i].key], true);
					if (!invalid) {
						valid = true;
						break;
					}
				}
				return !valid;
			});
		for (let group in grouped) {
			if (invalid_groups.indexOf(group) !== -1) {
				invalid_services = invalid_services.concat(grouped[group].map(service => service.key));
			}
		}
		
		return invalid_services;
	};
	
	useEffect(() => {
		const invalid_services            = findInvalidServices     (props.item.services,            services);
		const invalid_additional_services = findInvalidServices     (props.item.additional_services, additionalServices);
		const invalid_grouped_services    = findInvalidGroupServices(props.item.services,            services);
		
		setInvalidServices          (invalid_services);
		setInvalidAdditionalServices(invalid_additional_services);
		setInvalidGroupedServices   (invalid_grouped_services);
	}, [ services, additionalServices ]);
	
	const validateAndConfirm = () => {
		if (invalidServices.length > 0 || invalidAdditionalServices.length > 0 || invalidGroupedServices.length > 0) {
			setMarkInvalidServices(true);
			return;
		}
		
		props.onConfirm(services, additionalServices)
	};
	
	let services_items_grouped = [];
	for (let i=0; i<props.item.services.length; i++) {
		const service = props.item.services[i];
		const grp = service['group'] ?? null;
		if (services_items_grouped.length == 0 || grp === null || services_items_grouped[services_items_grouped.length - 1].group != grp) { // grp === null) {
			services_items_grouped.push({ group: grp, items: [ service ] });
		}
		else {
			services_items_grouped[services_items_grouped.length - 1].items.push(service);
		}
	}
	
	return <Modal
		className='accommodation-details-modal'
		show={true}
		onHide={() => console.log('hide')}
		renderBackdrop={() => <div className='accommodation-details-modal-backdrop' />}>
		<div>
			<div className='accommodation-details-modal-content'>
				<div className='text-bold mb-1'>
					{ getTrans(props.trans, 'fe__accommodation_details_dialog__title', props.lang) }
				</div>
				
				<div className='service-dialog-services'>
					{services_items_grouped.map((group, idx) =>
						<div key={'group-' + idx} className='service-dialog-services-group'>
						{group.items.map(service =>
							<AccommodationDetailsDialogService
								key={'service-' + service.key}
								lang={props.lang}
								type='service'
								service={service}
								services={services}
								invalid={(invalidServices.indexOf(service.key) > -1 || invalidGroupedServices.indexOf(service.key) > -1) && markInvalidServices}
								onChange={services => setServices(services)} />
						)}
						</div>
					)}
				</div>
				
				{props.item.additional_services.length == 0 ? null :
					<div>
						<div className='additional-services-title'>{ getTrans(props.trans, 'fe__accommodation_details_dialog__additional_services__title', props.lang) }</div>
						{props.item.additional_services.map(service => {
							return <div key={'additional-service-' + service.key} className='service-dialog-services-group'>
								<AccommodationDetailsDialogService
									className='additional-service'
									lang={props.lang}
									type='additional-service'
									service={service}
									services={additionalServices}
									invalid={invalidAdditionalServices.indexOf(service.key) > -1 && markInvalidServices}
									onChange={services => setAdditionalServices(services)} />
							</div>;
							/*if (service.type == 'bool') {
								return <div key={'additional-service-' + service.key} className='additional-service'>
									<label htmlFor={ 'additional-service-' + service.key } className='additional-service-title'>{ service.title }</label>
									<div className='additional-service-value'>
										<div className='additional-service-value-checkbox'>
											<input
												id={ 'additional-service-' + service.key }
												type='checkbox'
												checked={ additionalServices[service.key] }
												onChange={e => {
													const new_additional_services = { ...additionalServices };
													new_additional_services[service.key] = e.target.checked;
													setAdditionalServices(new_additional_services);
												}} />
										</div>
									</div>
								</div>;
							}
							else if (service.type == 'count') {
								return <div key={'additional-service-' + service.key} className='additional-service'>
									<label htmlFor={ 'additional-service-' + service.key } className='additional-service-title'>{ service.title }</label>
									<div className='person-count'>
										<div className='person-count-input'>
											<button className='person-count-input-neg' disabled={(additionalServices[service.key] ?? 0) == 0} onClick={() => {
												const new_counts = { ...additionalServices };
												new_counts[service.key] = Math.max(0, (new_counts[service.key] ?? 0) - 1);
												setAdditionalServices(new_counts);
											}}>-</button>
											<div className='person-count-input-number'>{ additionalServices[service.key] ?? 0 }</div>
											<button className='person-count-input-pos' onClick={() => {
												const new_counts = { ...additionalServices };
												new_counts[service.key] = (new_counts[service.key] ?? 0) + 1; //TODO upper limit?
												setAdditionalServices(new_counts);
											}}>+</button>
										</div>
									</div>
								</div>;
							}
							else if (service.type == 'counts') {
			  					return <div key={'additional-service-' + service.key}>
					  				<div className='additional-service-title'>{ service.title }</div>
									<div className='person-counts'>
										{service.values.map(val => { return { title: val.title, key: val.key, min: 0 }; }).map((item, idx) =>
											<div className='person-count' key={'person-count-' + idx}>
												<div className='person-count-input'>
													<button className='person-count-input-neg' disabled={(additionalServices[service.key][item.key] ?? 0) == item.min} onClick={() => {
														const new_counts = { ...additionalServices };
														new_counts[service.key][item.key] = Math.max(item.min, (new_counts[service.key][item.key] ?? 0) - 1);
														setAdditionalServices(new_counts);
													}}>-</button>
													<div className='person-count-input-number'>{ additionalServices[service.key][item.key] ?? 0 }</div>
													<button className='person-count-input-pos' onClick={() => {
														const new_counts = { ...additionalServices };
														new_counts[service.key][item.key] = (new_counts[service.key][item.key] ?? 0) + 1; //TODO upper limit?
														setAdditionalServices(new_counts);
													}}>+</button>
												</div>
												<div className='person-count-title'>{ item.title }</div>
											</div>
										)}
									</div>
								</div>;
							}*/
							return null;
						})}
					</div>
				}
			</div>
			<div className='accommodation-details-modal-actions'>
				<button className='button' onClick={props.onCancel}>
					{ getTrans(props.trans, 'fe__accommodation_details_dialog__cancel', props.lang) }
				</button>
				<button
					className='button primary-button'
					onClick={validateAndConfirm}
					disabled={invalidServices.length > 0 || invalidAdditionalServices.length > 0}>
					{ getTrans(props.trans, 'fe__accommodation_details_dialog__continue', props.lang) }
				</button>
			</div>
		</div>
	</Modal>
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
